"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelnovo-di-sotto": {
    "322da320": [{
      "hkey": "4800888a",
      "slug": "castelnovo-di-sotto",
      "name": "Castelnovo di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "cogruzzo": [{
      "hkey": "4800888a",
      "slug": "castelnovo-di-sotto",
      "name": "Castelnovo di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "845073cd": [{
      "hkey": "4800888a",
      "slug": "castelnovo-di-sotto",
      "name": "Castelnovo di Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "san-savino": [{
      "hkey": "4800888a",
      "slug": "castelnovo-di-sotto",
      "name": "Castelnovo di Sotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;